import React, { useState } from "react";
import classes from "./matchingRules.module.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import building from "../../Assets/reconicon.png";
import {
    Search,
    ChevronDown,
    MoreVertical,
    Upload,
    Plus,
    // BadgeCheck,
    // ArrowRightLeft,
    // CheckCircle2,
    // CircleDashed,
    // Percent,
    X,
    Printer,
    Info,
} from "lucide-react";

const ruleRows = [
    {
        name: "Exact Reference Match",
        description: "Match by reference number",
        badges: [
            { label: "Exact", tone: "green" },
            { label: "Reference = Reference", tone: "slate" },
        ],
        value: "18,420",
        percent: "98.6%",
        progress: 98.6,
        status: "Active",
        statusTone: "green",
        updated: "12 Jan, 2026",
        time: "10:31 AM",
    },
    {
        name: "Exact Amount Match",
        description: "Match by amount",
        badges: [
            { label: "Exact", tone: "green" },
            { label: "Amount = Amount", tone: "slate" },
        ],
        value: "12,810",
        percent: "96.6%",
        progress: 96.6,
        status: "Active",
        statusTone: "green",
        updated: "05 Feb, 2026",
        time: "08:42 AM",
    },
    {
        name: "Exact Reference Match",
        description: "Match by reference number",
        badges: [
            { label: "Combined", tone: "blue" },
            { label: "Reference = Reference AND Amount = Amount", tone: "slate" },
        ],
        value: "350",
        percent: "98.2%",
        progress: 98.2,
        status: "Active",
        statusTone: "green",
        updated: "18 Feb, 2026",
        time: "04:21 PM",
    },
    {
        name: "Exact Reference Match",
        description: "Match by reference number",
        badges: [
            { label: "Combined", tone: "blue" },
            { label: "Customer = Customer AND Amount = Amount", tone: "slate" },
        ],
        value: "4,210",
        percent: "93.2%",
        progress: 93.2,
        status: "Active",
        statusTone: "green",
        updated: "22 Feb, 2026",
        time: "04:31 PM",
    },
    {
        name: "Exact Reference Match",
        description: "Match by reference number",
        badges: [
            { label: "Fuzzy", tone: "orange" },
            { label: "Amount = Amount AND Date + 2 days", tone: "slate" },
        ],
        value: "2,840",
        percent: "91.0%",
        progress: 91,
        status: "Active",
        statusTone: "green",
        updated: "01 Mar, 2026",
        time: "08:45 AM",
    },
    {
        name: "Exact Reference Match",
        description: "Match by reference number",
        badges: [
            { label: "Fuzzy", tone: "orange" },
            { label: "Narration Similarity ~ 90% AND Amount = Amount", tone: "slate" },
        ],
        value: "1,210",
        percent: "88.3%",
        progress: 88.3,
        status: "Active",
        statusTone: "green",
        updated: "05 Mar, 2026",
        time: "07:48 AM",
    },
    {
        name: "Exact Reference Match",
        description: "Match by reference number",
        badges: [
            { label: "Combined", tone: "blue" },
            { label: "Sum(Ledger Amounts) = Bank Amount", tone: "slate" },
        ],
        value: "350",
        percent: "94.7%",
        progress: 94.7,
        status: "Active",
        statusTone: "green",
        updated: "01 Mar, 2026",
        time: "01:21 PM",
    },
];

const stats = [
    { label: "Total Rules", value: "16", subtitle: "Active matching rules", icon: building, tone: "default" },
    { label: "Auto Matched", value: "48,210", subtitle: "Transactions matched", icon: building, tone: "green" },
    { label: "Match Rate", value: "78.4%", subtitle: "Of all total transactions", icon: building, tone: "teal" },
    { label: "Manual Overrides", value: "842", subtitle: "This month", icon: building, tone: "amber" },
    { label: "Rule Efficiency", value: "96.2%", subtitle: "Successful matches", icon: building, tone: "purple" },
];

const MatchingRules = () => {
    const [isRuleModalOpen, setIsRuleModalOpen] = useState(false);

    return (
        <div className={classes.page}>
            <Header />
            <Sidebar />

            <main className={classes.main}>
                <div className={classes.container}>
                    <section className={classes.topSection}>
                        <div className={classes.topToolbar}>
                            <div className={classes.headerSection}>
                                <div>
                                    <h1 className={classes.title}>Matching Rules</h1>
                                    <p className={classes.subtitle}>Create and manage rules to automatically match bank and lodger transactions.</p>
                                </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <div className={classes.toolbarGroup}>
                                    <button className={classes.toolbarAction} aria-label="Export rules">
                                        <Upload size={16} />
                                        <p>Export</p>
                                    </button>
                                </div>
                                <button
                                    className={classes.primaryButton}
                                    onClick={() => setIsRuleModalOpen(true)}
                                >
                                    <Plus size={18} />
                                    Create New Rule
                                </button>
                            </div>

                        </div>

                        <div className={classes.statsGrid}>
                            {stats.map((item) => {
                                const Icon = item.icon;
                                return (
                                    <div key={item.label} className={classes.statCard}>
                                        <div className={`${classes.statIcon} ${classes[item.tone]}`}>
                                            {typeof Icon === "string" ? (
                                                <img src={Icon} alt="" />
                                            ) : (
                                                <Icon size={18} />
                                            )}
                                        </div>
                                        <div className={classes.statText}>
                                            <div className={classes.statLabel}>{item.label}</div>
                                            <div className={classes.statValue}>{item.value}</div>
                                            <div className={classes.statSubtitle}>{item.subtitle}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </section>

                    <section className={classes.tableSection}>
                        <div className={classes.filterRow}>
                            <div className={classes.searchBox}>
                                <input type="text" value="Search rules" readOnly />
                                <Search size={17} className={classes.searchIcon} />
                            </div>

                            <div className={classes.selectWrap}>
                                <select defaultValue="All Rule Types">
                                    <option>All Rule Types</option>
                                </select>
                                <ChevronDown size={16} className={classes.selectIcon} />
                            </div>

                            <div className={classes.selectWrap}>
                                <select defaultValue="All Statuses">
                                    <option>All Statuses</option>
                                </select>
                                <ChevronDown size={16} className={classes.selectIcon} />
                            </div>

                            <div className={classes.selectWrap}>
                                <select defaultValue="All Priorities">
                                    <option>All Priorities</option>
                                </select>
                                <ChevronDown size={16} className={classes.selectIcon} />
                            </div>

                            <div className={classes.selectWrap}>
                                <select defaultValue="Created by All">
                                    <option>Created by All</option>
                                </select>
                                <ChevronDown size={16} className={classes.selectIcon} />
                            </div>
                        </div>

                        <div className={classes.tableWrapper}>
                            <table className={classes.ruleTable}>
                                <thead>
                                    <tr>
                                        <th>Rule Name</th>
                                        <th>Types &amp; Conditions</th>
                                        <th>Performance (This Month)</th>
                                        <th>Status</th>
                                        <th>Last Updated</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {ruleRows.map((rule, index) => (
                                        <tr key={`${rule.name}-${index}`}>
                                            <td className={classes.ruleCell}>
                                                <div className={classes.ruleName}>{rule.name}</div>
                                                <div className={classes.ruleDescription}>{rule.description}</div>
                                            </td>
                                            <td>
                                                <div className={classes.badgeRow}>
                                                    {rule.badges.map((badge, badgeIndex) => (
                                                        <span
                                                            key={`${rule.name}-${badge.label}-${badgeIndex}`}
                                                            className={`${classes.badge} ${classes[badge.tone]}`}
                                                        >
                                                            {badge.label}
                                                        </span>
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                <div className={classes.performanceValueRow}>
                                                    <span className={classes.performanceNumber}>{rule.value}</span>
                                                    <span className={classes.metricValue}>({rule.percent})</span>
                                                </div>
                                                <div className={classes.progressTrack}>
                                                    <span className={classes.progressFill} style={{ width: `${rule.progress}%` }} />
                                                </div>
                                            </td>
                                            <td>
                                                <span className={`${classes.statusPill} ${classes[rule.statusTone]}`}>
                                                    {rule.status}
                                                </span>
                                            </td>
                                            <td className={classes.dateCell}>
                                                <div>{rule.updated}</div>
                                                <div className={classes.timeText}>{rule.time}</div>
                                            </td>
                                            <td className={classes.actionCell}>
                                                <button className={classes.moreBtn} aria-label="Open row actions">
                                                    <MoreVertical size={16} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section className={classes.detailPanel}>
                        <div className={classes.detailInfo}>
                            <div className={classes.detailHeader}>
                                <div className={classes.detailTitle}>Rule Details</div>
                                <button className={classes.editButton}>Edit Rule</button>
                            </div>

                            <div className={classes.detailMetaRow}>
                                <div className={classes.detailName}>Exact Reference Match</div>
                                <span className={`${classes.statusPill} ${classes.green}`}>Active</span>
                            </div>

                            <div className={classes.infoBlock}>
                                <span className={classes.label}>Description</span>
                                <p>Matches transactions using the exact reference number.</p>
                            </div>

                            <div className={classes.infoGrid}>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Rule Type</span>
                                    <p>Exact Match</p>
                                </div>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Priority</span>
                                    <p>1</p>
                                </div>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Created by</span>
                                    <p>Adekunle O.</p>
                                </div>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Created On</span>
                                    <p>12 Jan, 2026</p>
                                </div>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Last Modified</span>
                                    <p>01 Aug, 2026</p>
                                </div>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Total Matches</span>
                                    <p>186,420 (38.2% of total)</p>
                                </div>
                                <div className={classes.infoBlock}>
                                    <span className={classes.label}>Success Rate</span>
                                    <p>98.6%</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.detailExample}>
                            <div className={classes.exampleHeader}>Example</div>
                            <div className={classes.exampleGrid}>
                                <div className={classes.exampleCard}>
                                    <div className={classes.exampleTitle}>Bank Transaction</div>
                                    <div className={classes.exampleDataBlock}>
                                        <span>Reference:</span>
                                        <strong>TRF/2026/0814/001</strong>
                                    </div>
                                    <div className={classes.exampleDataBlock}>
                                        <span>Amount:</span>
                                        <strong>N250,000.00</strong>
                                    </div>
                                </div>

                                <div className={classes.exampleCard}>
                                    <div className={classes.exampleTitle}>Ledger Transaction</div>
                                    <div className={classes.exampleDataBlock}>
                                        <span>Reference:</span>
                                        <strong>TRF/2026/0814/001</strong>
                                    </div>
                                    <div className={classes.exampleDataBlock}>
                                        <span>Amount:</span>
                                        <strong>N250,000.00</strong>
                                    </div>
                                </div>
                            </div>

                            <div className={classes.matchResult}>Match Result: Matched</div>

                            <div className={classes.conditionBox}>
                                <div className={classes.conditionTitle}>Rule Condition</div>
                                <div className={classes.conditionLine}>
                                    <span className={classes.conditionOperator}>IF</span>
                                    <span className={classes.conditionKey}>Reference (Bank)</span>
                                    <span className={classes.conditionEquals}>equals</span>
                                    <span className={classes.conditionKey}>Reference (Ledger)</span>
                                </div>
                            </div>

                            <div className={classes.performanceBox}>
                                <div className={classes.conditionTitle}>Rule Performance (This Month)</div>
                                <div className={classes.metricsGrid}>
                                    <div className={classes.metricCard}>
                                        <div className={classes.metricRow}>
                                            <span className={classes.metricIndicator} />
                                            <span>Matches</span>
                                        </div>
                                        <div className={classes.metricNumber}>18,420</div>
                                    </div>
                                    <div className={classes.metricCard}>
                                        <div className={classes.metricRow}>
                                            <span className={classes.metricIndicatorSuccess} />
                                            <span>Success Rate</span>
                                        </div>
                                        <div className={classes.metricNumber}>98.6%</div>
                                    </div>
                                    <div className={classes.metricCard}>
                                        <div className={classes.metricRow}>
                                            <span className={classes.metricIndicatorAuto} />
                                            <span>Auto Matched</span>
                                        </div>
                                        <div className={classes.metricNumber}>17,956</div>
                                    </div>
                                    <div className={classes.metricCard}>
                                        <div className={classes.metricRow}>
                                            <span className={classes.metricIndicatorManual} />
                                            <span>Manual Matched</span>
                                        </div>
                                        <div className={classes.metricNumber}>464</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </main>

            {isRuleModalOpen && (
                <div className={classes.modalOverlay} onMouseDown={() => setIsRuleModalOpen(false)}>
                    <section className={classes.ruleModal} role="dialog" aria-modal="true" aria-labelledby="create-rule-title" onMouseDown={(event) => event.stopPropagation()}>
                        <div className={classes.modalHeader}>
                            <h2 id="create-rule-title">Create New Rule</h2>
                            <button className={classes.closeButton} aria-label="Close create rule dialog" onClick={() => setIsRuleModalOpen(false)}><X size={25} /></button>
                        </div>

                        <div className={classes.stepper}>
                            {[["1", "Rule Detail"], ["2", "Select Sources"], ["3", "Matching Rules"], ["4", "Review & Start"]].map(([number, label], index) => (
                                <React.Fragment key={label}>
                                    <div className={`${classes.modalStep} ${index === 0 ? classes.currentStep : ""}`}>
                                        <span className={classes.stepNumber}>{number}</span><span>{label}</span>
                                    </div>
                                    {index < 3 && <span className={classes.stepConnector} />}
                                </React.Fragment>
                            ))}
                        </div>

                        <div className={classes.modalBody}>
                            <ModalSection title="Rule Details">
                                <div className={classes.modalFormGrid}>
                                    <ModalField label="Rule Name" required placeholder="A descriptive name for this rule" />
                                    <ModalField label="Rule Description (Optional)" placeholder="What this rule is designed to match" />
                                    <ModalField label="Rule Type" placeholder="Select rule type" select />
                                    <ModalField label="Priority" placeholder="Select priority" select />
                                </div>
                            </ModalSection>
                            <ModalSection title="Applies To">
                                <div className={classes.modalFormGridThree}>
                                    <ModalField label="Bank Account(s)" required placeholder="select building type" select />
                                    <ModalField label="Ledger Account(s)" required placeholder="select use / occupancy" select />
                                    <ModalField label="Currency" required placeholder="select use / occupancy" select />
                                </div>
                            </ModalSection>
                            <ModalSection title="Conditions (What to Match)">
                                <div className={classes.conditionRow}>
                                    <ModalField placeholder="Reference (Bank)" select /><ModalField placeholder="Equals" select /><ModalField placeholder="Enter Value" select />
                                    <button className={classes.printButton} aria-label="Print condition"><Printer size={17} /></button>
                                </div>
                                <button className={classes.andButton}>AND <ChevronDown size={15} /></button>
                                <div className={classes.conditionRow}>
                                    <ModalField placeholder="Amount" select /><ModalField placeholder="Equals" select /><ModalField placeholder="Amount (Ledger)" select />
                                    <button className={classes.printButton} aria-label="Print condition"><Printer size={17} /></button>
                                </div>
                                <div className={classes.conditionActions}>
                                    <button className={classes.addConditionButton}>Add Condition <Plus size={17} /></button>
                                    <button className={classes.addConditionButton}>Add Condition Group <Plus size={17} /></button>
                                </div>
                                <div className={classes.conditionHint}><Info size={14} /> Conditions are evaluated from top to bottom. All conditions in a group must be true to find a match.</div>
                            </ModalSection>
                        </div>
                        <div className={classes.modalFooter}>
                            <button className={classes.cancelButton} onClick={() => setIsRuleModalOpen(false)}>Cancel</button>
                            <button className={classes.nextButton}>Next: Conditions</button>
                        </div>
                    </section>
                </div>
            )}
        </div>
    );
};

const ModalSection = ({ title, children }) => (
    <section className={classes.modalSection}>
        <h3>{title}</h3>
        {children}
    </section>
);

const ModalField = ({ label, required, placeholder, select }) => (
    <label className={classes.modalField}>
        {label && <span>{label}{required && <em>*</em>}</span>}
        <div className={classes.modalInput}>
            <input placeholder={placeholder} />
            {select && <ChevronDown size={16} />}
        </div>
    </label>
);

export default MatchingRules;